import { UserDetailsService } from "./../../login/services/UserDetails.service";
import { Component, OnInit } from "@angular/core";
import { ConfigService } from "../../utils/config.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation-sub.component.html",
  styleUrls: ["./navigation.component.css"],
})
export class NavigationComponent implements OnInit {
  isDp: boolean = ConfigService.settings.isDataProvider;

  private role = ConfigService.settings.role;

  navigationLinks = [
    { id: "overview", to: "overview", title: "Overview", satisfied: this.hasFOModuleRole() },
    { id: "info-management", to: "info-management", title: "AIS Data", satisfied: this.hasDataReaderRole() },
    { id: "update", to: "update", title: "Update Notices", satisfied: this.hasDataReaderRole() },
    { id: "quality/projects", to: "quality/projects", title: "Quality Assessment", satisfied: this.hasFqaModuleRole() },
    {
      to: null,
      id: "validator",
      title: "Validator",
      expanded: true,
      satisfied: this.hasValidatorModuleRole(),
      sub: [
        {
          id: "aixm-validator",
          to: "aixm-validator",
          title: "New Validation",
          satisfied: this.hasValidatorModuleRole(),
        },
        {
          id: "validation-history",
          to: "validation-history",
          title: "My Validations",
          satisfied: this.hasValidatorModuleRole(),
        },
        {
          id: "validation-stats",
          to: "validation-stats",
          title: "Statistics",
          satisfied: this.hasValidatorModuleRole(),
        },
      ],
    },
    {
      to: null,
      id: 'governance',
      title: 'Governance',
      expanded: true,
      satisfied: true,
      sub: [
        { id: 'data-catalogue', to: "data-catalogue", title: "Data Catalogue", satisfied: true},
        { id: "provider", to: "provider", title: "Data Providers", satisfied: this.isAdmin() },
        { id: "profile", to: "profile", title: "AIXM Profiles", satisfied: this.isDataManager() },
        { id: "log-sheet", to: "log-sheet", title: "Log Sheets", satisfied: this.hasLSModuleRole() }
      ]
    }
  ];

  constructor(private userDetailsService: UserDetailsService, private router: Router) {}

  ngOnInit() {
    this.setInitialLinkExpanded();
  }

  // Check the current user has ROLE_FACILIS_ORIGIN_MODULE
  hasFOModuleRole(): boolean {
    return true;
  }

  // Check the current user is AIS admin
  isAdmin(): boolean {
    return true;
  }

  // Check the current user is Data manger
  isDataManager(): boolean {
    return true;
  }

  // Check the current user is Data reader
  hasDataReaderRole(): boolean {
    return true;
  }

  // Check the current user has ROLE_LOG_SHEET_MODULE role
  hasLSModuleRole(): boolean {
    return true;
  }

  // Check the current user has ROLE_FQA_MODULE role
  hasFqaModuleRole(): boolean {
    return true;
  }

  // Check the current user has ROLE_FAIVA_MODULE role
  hasValidatorModuleRole(): boolean {
    return false;
  }

  setInitialLinkExpanded(): void {
    const intialExpanded = this.navigationLinks
      .filter((link) => !!link.sub)
      .find((link) => link.sub.some((value) => this.router.url.includes(value.to)));

    console.log(intialExpanded, "### intialExpanded");

    if (intialExpanded) {
      intialExpanded.expanded = true;
    }
  }
}
